// extracted by mini-css-extract-plugin
export default {"modal":"ModalSetLanguage_modal__thGRX","close":"ModalSetLanguage_close__sxx8S"};